module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "specification row no-gutters"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "specification__title"
  }, [_vm._v("\n      SPECIFICATIONS\n    ")]), _c('div', {
    staticClass: "specification__content"
  }, _vm._l((_vm.attributes), function(item, index) {
    return (item.value) ? _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "specification__content__title"
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")]), _c('div', {
      staticClass: "specification__content__text"
    }, [_vm._v("\n          " + _vm._s(item.value) + "\n        ")])]) : _vm._e()
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-720d588d","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/Specification.vue
// module id = 1177
// module chunks = 23 25